import styled from 'styled-components/macro';

export const Button = styled.button`
  background-color: #44b1df;
  width: 16rem;
  border: 0 solid #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.8rem 2rem;
  margin-top: 15px;
  transition: 0.2s;

  &:hover {
    background-color: #545454;
  }
`;
